import * as o from "react";
import c from "../lib/IconBase.es.js";
import e from "../defs/Calculator.es.js";
const a = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(c, { ref: t, ...r, weights: e }));
a.displayName = "CalculatorIcon";
const s = a;
export {
  s as Calculator,
  a as CalculatorIcon
};
